import { useQuery } from "@tanstack/react-query";
import { TanstackQueryKey } from "apps/commons/tanstackQueryKey";
import type { AxiosError } from "axios";
import { oneOnboardingApi } from "libs/api";
import type { LocationDropdownItems, PropertyData } from "libs/codegen/property-onboarding";
import { useState } from "react";
import { useWatch } from "react-hook-form";
import { useParams } from "router";
import { useDynamicLocation } from "../../commons/hooks/useDynamicLocation";
import { useStaticDataAtomValue } from "../staticDataAtom";
import { useSetStatesCitiesAtom } from "./manual/statesCitiesAtom";

export const useStateCityHandler = () => {
    const { lang } = useParams("/:lang/list-my-property/onboard/:propertyId/location");
    const setStatesCitiesAtom = useSetStatesCitiesAtom();
    const countryId = useWatch<PropertyData>({
        name: "country.id",
    }) as number;
    const stateId = useWatch<PropertyData>({
        name: "state.id",
    }) as number;

    const {
        cmsData: {
            location: { weDontSupportThisCountryForNow },
        },
    } = useStaticDataAtomValue();
    const [error, setError] = useState<undefined | string>(undefined);
    const { pathname } = useDynamicLocation();

    useQuery({
        queryKey: [TanstackQueryKey.GetLocationDropdown, lang, countryId, stateId, pathname],
        queryFn: () => {
            if (countryId || stateId)
                return oneOnboardingApi
                    .getLocationDropdown(lang, countryId ?? 0, stateId ?? 0, pathname)
                    .then((res) => res.data);

            return {
                cities: [],
                states: [],
            } satisfies LocationDropdownItems;
        },
        onSuccess: (data) => {
            setError(undefined);
            setStatesCitiesAtom({
                states: data.states ?? [],
                cities: data.cities ?? [],
            });
        },
        onError: (err: AxiosError) => {
            switch (err.status) {
                case 400:
                    setError(weDontSupportThisCountryForNow);
                    break;
                default:
                    throw err;
            }
        },
        retry: false,
    });

    return {
        error,
    };
};
